import { makeAutoObservable } from "mobx";

export class SidebarStore {
  isOpen: boolean = false;

  constructor() {
    makeAutoObservable(this);
    // Load initial state from localStorage if available (only in browser)
    if (typeof window !== "undefined") {
      const savedState = localStorage.getItem("sidebarOpen");
      if (savedState !== null) {
        this.isOpen = JSON.parse(savedState);
      }
    }
  }

  toggle = () => {
    this.isOpen = !this.isOpen;
    this.saveToLocalStorage();
  };

  open = () => {
    this.isOpen = true;
    this.saveToLocalStorage();
  };

  close = () => {
    this.isOpen = false;
    this.saveToLocalStorage();
  };

  private saveToLocalStorage = () => {
    // Only save to localStorage in browser environment
    if (typeof window !== "undefined") {
      localStorage.setItem("sidebarOpen", JSON.stringify(this.isOpen));
    }
  };

  // Refresh state from localStorage (useful after page reload)
  refreshFromLocalStorage = () => {
    if (typeof window !== "undefined") {
      const savedState = localStorage.getItem("sidebarOpen");
      if (savedState !== null) {
        this.isOpen = JSON.parse(savedState);
      }
    }
  };
}

export const sidebarStore = new SidebarStore();
